/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import logo from "assets/logo/main_logo.png";
import routes from "routes.js";

const Sidebar = ({ open, onClose }) => {
  // Determine authentication state from localStorage (same logic as App)
  const isAuthed = Boolean(
    localStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    (localStorage.getItem("isAuthenticated") === "true")
  );

  // Hide auth routes (e.g., Sign In) when authenticated
  const filteredRoutes = isAuthed ? routes.filter((r) => r.layout !== "/auth") : routes;

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex h-screen flex-col overflow-y-auto scrollbar-y-hide  bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[50px] mt-[25px] flex items-center w-[120px]`}>
       <img src={logo} alt="" />
      </div>
      <div class="mt-[25px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={filteredRoutes} />
      </ul>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
